import { Search } from 'lucide-react';
import { Input } from '@/components/Input';
import { StatusSelect } from '@/components/StatusSelect';
import { ViewModeToggle, type ViewMode } from '@/components/ViewModeToggle';
import type { JobStatus } from '@maker-toolchest/shared';

interface JobFiltersProps {
  search?: string;
  status?: JobStatus | '';
  viewMode: ViewMode;
  onSearchChange: (value: string) => void;
  onStatusChange: (value: JobStatus | '') => void;
  onViewModeChange: (mode: ViewMode) => void;
}

export function JobFilters({
  search = '',
  status = '',
  viewMode,
  onSearchChange,
  onStatusChange,
  onViewModeChange,
}: JobFiltersProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-3 items-stretch sm:items-center">
      {/* Search */}
      <div className="flex-1">
        <Input
          type="text"
          placeholder="Search jobs..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          leftIcon={<Search className="h-5 w-5" />}
        />
      </div>

      {/* Status Filter */}
      <div className="w-full sm:w-48">
        <StatusSelect value={status} onChange={onStatusChange} />
      </div>

      {/* View Mode Toggle */}
      <ViewModeToggle value={viewMode} onChange={onViewModeChange} />
    </div>
  );
}
